export function getTenantSlugFromHostname(): string | null {
  if (typeof window === 'undefined') return null;
  
  const hostname = window.location.hostname;
  
  const params = new URLSearchParams(window.location.search);
  const tenantParam = params.get('tenant');
  if (tenantParam) {
    return tenantParam;
  }
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'demo';
  }
  
  const parts = hostname.split('.');
  
  if (parts.length >= 3 && parts[parts.length - 2] === 'medsystem') {
    return parts[0];
  }
  
  if (parts.length >= 3 && parts[parts.length - 2] === 'vercel') {
    const previewTenant = import.meta.env.VITE_PREVIEW_TENANT_SLUG;
    if (previewTenant) {
      return previewTenant;
    }
    return null;
  }
  
  return null;
}

export function getTenantContext() {
  const slug = getTenantSlugFromHostname();
  return {
    slug,
    isMultiTenant: !!slug,
  };
}
